import { globalModule } from './global.module';
import { CurrentUserService } from 'src/app/shared/services/current-user.service';
import { firstValueFrom, of } from 'rxjs';
import { filter, take, timeout, catchError } from 'rxjs/operators';
import { ConfigService } from '../config/config.service';
import { ENVIRONMENT_META_TOKEN } from '../config/config.tokens';

onBeforeHookRunBlock.$inject = ['$transitions'];

let unregisterEnvironmentRoleHook: (() => void) | null = null;

const checkAuthorisationForCurrentEnvironment = async (transition) => {
  // Prevent redirect loops
  const from = transition.from();
  if (from?.name === 'unauthorizedForEnvironment') return false;

  // Resolve Angular services/tokens via the hybrid injector
  const cfg: ConfigService = transition.injector().get(ConfigService as any);

  // Ensure config is fully ready before reading slices
  await cfg.whenReady();

  // Read needed config slice(s) (immutable snapshot)
  const env = transition.injector().get(ENVIRONMENT_META_TOKEN as any);
  const requiredRole = (env?.requiredRole || '').trim();

  // Only enforce in EAP/Canary-like environments (your policy)
  const shouldEnforce = env.eap || ['canary'].includes(env.name.toLowerCase());

  if (!requiredRole) {
    if (unregisterEnvironmentRoleHook) {
      unregisterEnvironmentRoleHook();
      unregisterEnvironmentRoleHook = null;
    }
    return true;
  }

  if (!shouldEnforce) {
    // No role enforcement required; proceed
    return true;
  }

  // Prefer Angular CurrentUserService via hybrid injector
  const currentUserService: CurrentUserService = transition.injector().get(CurrentUserService as any);

  // Start init() and wait deterministically for the first non-null user
  currentUserService.init();

  try {
    const u = await firstValueFrom(
      currentUserService.user$.pipe(
        filter(u => u !== null),
        take(1),
        timeout(5000),
        catchError(() => of(null))
      )
    );

    const roles: string[] = u?.roles || [];
    if (roles.includes(requiredRole)) {
      // Authorised
      return true;
    }

    // Not authorised — redirect
    return transition.router.stateService.target('unauthorizedForEnvironment');
  } catch (err) {
    // On timeout/error — deny and redirect
    console.error('Role guard error:', err);
    return transition.router.stateService.target('unauthorizedForEnvironment');
  }
};

function onBeforeHookRunBlock($transitions) {
  // Priority slightly above default so it runs after basic resolves but before
  // component activation; tune if needed.
  unregisterEnvironmentRoleHook = $transitions.onBefore({}, checkAuthorisationForCurrentEnvironment, { priority: 11 });
}

// Always register the run block; the guard itself decides whether to enforce.
// If you truly want to avoid any cost in prod, gate the run registration:
globalModule.run(onBeforeHookRunBlock);
// Or:
// if (/* lightweight static check */) globalModule.run(onBeforeHookRunBlock);




// import { globalModule } from './global.module';
// import { environment } from '../../environments/environment';
// import { CurrentUserService } from 'src/app/shared/services/current-user.service';
// import { firstValueFrom } from 'rxjs';
// import { filter, take, timeout } from 'rxjs/operators';
// /**
//  * This file contains a Transition Hook which enforces a
//  * required site role
//  *
//  * The checkAuthorisationForCurrentEnvironment hook is only
//  * activates if the environment is Canary or if the eap flag
//  * is set to true
//  *
//  * If the user's role array does not include the one that
//  * is listed in environments.requiredRole, s/he is redirected
//  * to  an 'unauthorised for this environment page
//  * This hook redirects to /login when both:
//  */
// onBeforeHookRunBlock.$inject = ['$transitions', '$window'];

// let checkAuthorisationForCurrentEnvironment = (transition) => {
//   // If the transition came from here then it should be
//   // ignored or else we will get into a transition loop
//   const transitionFrom = transition.from();
//   if (transitionFrom.name == 'unauthorizedForEnvironment') {
//     return false;
//   }

//   // Prefer the Angular CurrentUserService via the hybrid injector. Avoid
//   // resolving the legacy AngularJS 'CurrentUser' string token which can
//   // produce a NullInjectorError in some bootstrap ordering cases.
//   const currentUserService: CurrentUserService = transition.injector().get(CurrentUserService as any);

//   // Ensure init() is started and wait for the first non-null user emission
//   // before making the role decision (prevents race conditions).
//   currentUserService.init();
//   // Return the promise so UI-Router waits for the authorization decision.
//   return firstValueFrom(
//     currentUserService.user$.pipe(
//       filter(u => u !== null),
//       take(1),
//       timeout(5000)) // fail after 5s
//   ).then((u: any) => {
//     const roles: string[] = u?.roles || [];
//     if (roles.includes(environment.requiredRole)) {
//       console.log('### Site Role correct - able to proceed');
//       return true;
//     }
//     // return a TargetState (UI-Router will redirect)
//     console.error('### Site Role incorrect - unable to proceed:');
//     return transition.router.stateService.target('unauthorizedForEnvironment');
//     // transition.router.stateService.go('unauthorizedForEnvironment');
//     // return false;
//   }).catch(err => {
//     // on timeout or error, deny and redirect
//     console.error('Error while checking authorization for current environment:', err);
//     return transition.router.stateService.target('unauthorizedForEnvironment');
//     // transition.router.stateService.go('unauthorizedForEnvironment');
//     // return false;
//   });

// }

// function onBeforeHookRunBlock($transitions, $window) {
//   $transitions.onBefore({}, checkAuthorisationForCurrentEnvironment, { priority: 11 });
// }

// only register this hook if we are running in EAP or Canary mode
// this is an optimisation that will prevent us from having to
// make this chek on every route change while in production

// if (['canary'].includes(environment.name) || environment.eap) {
//   globalModule.run(onBeforeHookRunBlock);
// }


